var render = function render(){var _vm=this,_c=_vm._self._c;return (
    (_vm.$store.state.app &&
      _vm.$store.state.app.user.indexOf(_vm.$store.state.auth.uid) > -1) ||
    (_vm.$store.state.app.advanced.roles.admin &&
      _vm.$store.state.app.advanced.roles.admin.members &&
      _vm.$store.state.app.advanced.roles.admin.members.indexOf(
        _vm.$store.state.auth.uid
      ) > -1)
  )?_c('div',{staticClass:"container admin",staticStyle:{"height":"100%"},attrs:{"id":_vm.$store.state.app.basics.database+'_admin'}},[_c('keep-alive',[_c('iform',{tag:"component",class:'iform_' + _vm.app.name.norm(),staticStyle:{"height":"100%"},attrs:{"id":'iform_' + _vm.app.name.norm(),"form-model":_vm.app,"searchenabled":"true"}})],1)],1):_c('div',{staticClass:"container p8"},[_c('p',[_vm._v("You must be logged in as the app creator to access this admin.")]),_c('login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }